import { useMediaQuery, Stack } from '@mui/material'
import { GridFooterContainer, GridFooter } from '@mui/x-data-grid'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { setActiveRoute } from '../../../redux/reducers/appSettingsReducer'
import { StyledLink } from '../../../shared/UI/Link/components'
import { isMobileDown } from '../../../theme/deviceChecks'
import theme from '../../../theme/theme'
import actionsService from '../../../services/actionsService'

export function CustomFooterStatus() {
  const mobile = useMediaQuery(isMobileDown())
  const dispatch = useDispatch()
  return (
    <GridFooterContainer>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: '100%' }}
      >
        <>
          {!mobile && (
            <Link
              to="/wallchart"
              onClick={() => {
                actionsService.userAnalytics
                  .postEvent('UIClickEvent', 'DashboardWhosAwayViewWallChartClick', window.location.pathname, window.location.hostname)
                  .catch((error: unknown) => console.error('Analytics tracking error:', error))
                dispatch(setActiveRoute('/wallchart'))
              }}
              style={{ textDecoration: 'none', color: theme.palette.primary.main }}
            >
              <StyledLink data-testid="dashboard_away_link">View Wall Chart</StyledLink>
            </Link>
          )}
        </>
        <GridFooter />
      </Stack>
    </GridFooterContainer>
  )
}
